import { configureStore } from '@reduxjs/toolkit';
import { aitrasApi } from './api/aitrasApi';
import authReducer from './authSlice';
import accessReducer from './accessSlice';

// Import feature API slices to register their injected endpoints.
import '@/features/assessment/api/assessmentApi';
import '@/features/admin/api/adminApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    access: accessReducer,
    [aitrasApi.reducerPath]: aitrasApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(aitrasApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
